import classNames from "classnames";
import { Button } from "components/DesignSystem/Button/Button";
import { MultiSelectFilter } from "components/DesignSystem/Filter/Filter";
import HeaderFilter from "components/DesignSystem/HeaderFilter/HeaderFilter";
import { Funnel } from "components/icons/Funnel";
import { AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

export type UpdateFilterType = (name: string, value: string | null) => void;

export const ColumnHeaderMultiSelectFilter = ({
  updateFilter,
  filterName,
  options,
  selected,
  className = "t-w-64",
  loadNext,
  onSearch,
  hasMore,
  totalCount,
}: {
  filterName: string;
  options: { label: string; value: string }[];
  selected: string | null;
  updateFilter: UpdateFilterType;
  className?: string;
  loadNext?: () => void;
  onSearch?: (value: string) => void;
  hasMore?: boolean;
  totalCount?: number;
}) => {
  const [tempValues, setTempValues] = useState<string[]>(
    selected?.split(",") || []
  );
  const [isOpen, setOpen] = useState(false);
  const isActive = Boolean(selected && selected.length > 0);

  const updateFilterCallback = (newValues: string[]) => {
    setTempValues(newValues);
  };

  const applyFilter = () => {
    updateFilter(filterName, tempValues.join(","));
    setOpen(false);
  };

  useEffect(() => {
    setTempValues(selected?.split(",") || []);
  }, [selected]);

  return (
    <HeaderFilter.Root open={isOpen} setOpen={setOpen}>
      <HeaderFilter.Trigger
        icon={<Funnel />}
        isActive={isActive}
        selectedCount={selected?.split(",")?.length || 0}
        onClear={() => updateFilter(filterName, null)}
        setOpen={setOpen}
      />
      <AnimatePresence>
        <HeaderFilter.Portal {...HeaderFilter.Portal}>
          <HeaderFilter.Content
            className={classNames("t-overflow-auto t-max-h-80", {
              [className]: true,
            })}
          >
            <HeaderFilter.Body>
              <MultiSelectFilter
                isSelectAll
                onChange={(values) => updateFilterCallback(values)}
                checkboxSpace="small"
                options={options}
                selected={tempValues}
                loadNext={loadNext}
                onSearchValueChange={onSearch}
                hasMore={hasMore}
                totalCount={totalCount}
              />
            </HeaderFilter.Body>
            <HeaderFilter.Footer>
              <Button size="small" onClick={() => setOpen(false)}>
                Cancel
              </Button>
              <Button customType="primary" size="small" onClick={applyFilter}>
                Apply
              </Button>
            </HeaderFilter.Footer>
          </HeaderFilter.Content>
        </HeaderFilter.Portal>
      </AnimatePresence>
    </HeaderFilter.Root>
  );
};
